import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './TermsOfService.css';

export function TermsOfService() {
  return (
    <div className="terms-of-service">
      <header className="terms-of-service__header">
        <div className="terms-of-service__header-brand"></div>
        <Link to="/dashboard" className="terms-of-service__back-btn">
          <ArrowLeft size={18} />
          <span>Back to Dashboard</span>
        </Link>
      </header>

      <main className="terms-of-service__container">
        <article className="terms-of-service__card">
          <h1 className="terms-of-service__title">Terms of Service</h1>
          <p className="terms-of-service__last-updated">Last Updated: June 10, 2026</p>

          <section className="terms-of-service__intro">
            <p>
              These Terms of Service ("Terms") govern your access to and use of the MothNode Dashboard platform (the "Platform"), provided by LTRJ Labs LTD. ("we," "us," or "our"). By accessing or using the Platform, you agree to be bound by these Terms.
            </p>
          </section>

          <hr className="terms-of-service__divider" />

          <section className="terms-of-service__section">
            <h2>1. Account Security and API Key Responsibility</h2>
            <p>
              To transmit ground telemetry to specific folders on the Platform, LTRJ Labs LTD. issues unique API keys to designated Administrators.
            </p>
            <ul className="terms-of-service__list">
              <li>
                <strong>Credential Protection:</strong> You are solely responsible for maintaining the strict confidentiality of your AWS Cognito account credentials and any assigned API keys.
              </li>
              <li>
                <strong>Data Integrity:</strong> LTRJ Labs LTD. does not verify the physical accuracy of the telemetry sent to our servers. If your API key is lost, leaked, or stolen, you are entirely responsible for any resulting data corruption, malicious data injection, or unauthorized access to your folders. We are not liable for any losses or damages arising from your failure to secure your credentials.
              </li>
            </ul>
          </section>

          <section className="terms-of-service__section">
            <h2>2. Administrator Access and Data Liability</h2>
            <p>
              The Platform allows designated Administrators to manage specific folders and view the First Name, Last Name, and Email Address of users assigned to those areas.
            </p>
            <ul className="terms-of-service__list">
              <li>
                <strong>User-Assumed Risk:</strong> By joining a folder or area, you explicitly consent to your account information being visible to that area's Administrator(s).
              </li>
              <li>
                <strong>Administrator Misuse:</strong> LTRJ Labs LTD. provides the infrastructure for data viewing but does not monitor or control the actions of independent Administrators. We explicitly disclaim all liability for any unauthorized scraping, leaking, harassment, or misuse of your personal information by an Administrator. Any dispute regarding data misuse by an Administrator must be resolved directly between you and the offending party.
              </li>
            </ul>
          </section>

          <section className="terms-of-service__section">
            <h2>3. Telemetry Alerts and Limitation of Liability</h2>
            <p>
              The Platform allows users to configure automated email and SMS alerts based on specific ground data thresholds.
            </p>
            <ul className="terms-of-service__list">
              <li>
                <strong>No Guarantee of Delivery:</strong> You acknowledge that telemetry transmission, cloud processing, and third-party telecommunications (including AWS and Twilio) are subject to inherent delays, outages, and failures.
              </li>
              <li>
                <strong>Absolute Limitation of Liability:</strong> MothNode Dashboard is an informational tool, not a life-safety or critical infrastructure failsafe. LTRJ Labs LTD. shall not be held legally or financially liable for any physical damage, environmental contamination, lost product, business interruption, or financial loss resulting from a delayed, failed, or inaccurate SMS or email alert, regardless of whether the failure occurred on our servers or via a third-party gateway.
              </li>
            </ul>
          </section>

          <section className="terms-of-service__section">
            <h2>4. Acceptable Use and External Invitations</h2>
            <p>
              The Platform allows users to send data viewing invitations to external email addresses. You agree to use this feature strictly for legitimate operational purposes.
            </p>
            <ul className="terms-of-service__list">
              <li>
                <strong>Relationship Requirement:</strong> You may only send invitations to individuals with whom you have a personal, family, or existing business relationship.
              </li>
              <li>
                <strong>Prohibited Conduct:</strong> You are strictly prohibited from using the invitation feature to send unsolicited messages, spam, promotional material, or harassing communications.
              </li>
              <li>
                <strong>Penalties:</strong> Violation of this policy will result in the immediate and permanent termination of your account and API access without refund or notice.
              </li>
            </ul>
          </section>

          <section className="terms-of-service__section">
            <h2>5. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless LTRJ Labs LTD., its officers, directors, and employees from and against any claims, fines, damages, losses, or legal fees arising from:
            </p>
            <ul className="terms-of-service__list">
              <li>
                Your violation of these Terms.
              </li>
              <li>
                Your misuse of API keys resulting in data corruption.
              </li>
              <li>
                Your use of the external invitation tool resulting in spam complaints, telecom fines, or violations of anti-spam legislation (such as CASL or the TCPA).
              </li>
            </ul>
          </section>

          <section className="terms-of-service__section">
            <h2>6. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of the Province of British Columbia and the federal laws of Canada applicable therein, without regard to its conflict of law provisions. You agree to submit to the exclusive jurisdiction of the provincial and federal courts located within British Columbia to resolve any legal matter arising from these Terms or your use of the Platform.
            </p>
          </section>
        </article>
      </main>
    </div>
  );
}

export default TermsOfService;
